/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { authActions, selectAuth } from "Features/auth";
import SelectLanguage from "Widgets/lang_select";
import { EyeIcon } from "Shared/icons";
import { Button, Input } from "Shared/ui";
import { errorActions, selectError } from "Features/error";

export const SetNewPasswordpage = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const errPage = useSelector(selectError.page);
	const errMessage = useSelector(selectError.message);
	const fetch = useSelector(selectAuth.fetch);
	const succes = useSelector(selectAuth.succes);
	const [password, setPassword] = useState("");
	const location = useLocation();
	const search = location.search;
	const token = search
		?.split("?")
		?.find((item) => item.includes("token"))
		?.split("=")
		?.pop();

	useEffect(() => {
		return () => {
			dispatch(authActions.drop());
			dispatch(errorActions.drop());
		};
	}, []);
	useEffect(() => {
		if (succes) {
			navigate("/auth/login");
		}
	}, [succes]);

	function onSetPass() {
		dispatch(authActions.setPass({ password, token }));
	}

	return (
		<div className="auth">
			<div className="auth__container auth__container_w500">
				<div className="auth__block">{/* <SelectLanguage /> */}</div>
				<div className="auth__line mb-30" />
				<div className="auth__block mb-30">
					<div className="auth__block-text mb-30">
						<span className="auth__block-text_big">Password recovery</span>
					</div>
					<div className="auth__block-container">
						<Input
							placeholder="Password*"
							type={"password"}
							className="mb-17"
							outValue={password}
							setOutValue={setPassword}
							// errorMessage={errors.password}
							Icon={EyeIcon}
							errorMessage={errPage === "set-pass" && errMessage}
						/>
					</div>
					<Button text="SET NEW PASSWORD" className="mb-5" onClick={onSetPass} isLoading={fetch} disabled={!password} />
				</div>
			</div>
		</div>
	);
};
